import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-37fa5daa"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "i-copyright"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "copyright-text"
  }, "© 2024 崇福皮毛管理系统 版权所有", -1 /* HOISTED */);
});
var _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [].concat(_hoisted_3));
}